<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status" :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 :primary-key-column="'activity'+activityNumber+'ChildId'"
                 :primary-key="form['activity'+activityNumber+'ChildId']"
                 :foreign-key-column="foreignKeyColumn" :foreign-key="foreignKey"
                 title-items="Itens" sortable
                 enable-change-order-up-down
                 disable-footer-length
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit"
                 @onItemRead="onItemReadDefault"
                 @onItemDelete="onItemDeleteDefault">

      <template #default="{status}">


        <b-col cols="12" class="mb-2">

          <b-row>

            <b-col xl="6">

              <t-page-form-field-customized
                  ref="fieldsGeneral"
                  :command="command" :status="status" :user-auth="userAuth"
                  :fields-customizable="entityFieldCustomized('page')"
                  :primary-key="form['activityChild'+activityNumber+'Id']" :foreign-key="currentPage.pageId"
                  :busy="!pageFormIsLoaded"
                  :primary-key-column="fieldKey" foreign-key-column="pageId"
              />



            </b-col>

            <b-col xl="3">
              <t-input v-model="form.note" label="Obs."/>
            </b-col>



            <b-col xl="3" class="button-form-inline">

              <t-button :sending="status === 'sending'" :text="onButtonSubmitText(command) + ' Item'" no-icon submit/>

              <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                {{ t('go-back') }}
              </b-link>

            </b-col>

          </b-row>

        </b-col>




      </template>

    </t-form-list>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import pageViewService from "@/services/modules/setting/PageView.service";


export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'ChecklistActivityFormChildEmbeddable',
  data() {
    return {
      path: "checklist/activity-child" + this.activityNumber, //Utilizar somente quando fora do padrão
      foreignKeyColumn: "activity" + this.activityNumber + "Id", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "activity" + this.activityNumber + "ChildId", keyDelete: "activity" + this.activityNumber + "ChildId"},

      ],
      enableGeneralFields: true,
      fieldKey: "activityChild" + this.activityNumber + "Id",
      form: {
        ["activity" + this.activityNumber + "Id"]: this.foreignKey,
        ["activity" + this.activityNumber + "ChildId"]: 0,
        checklistId: this.checklistId,
        name: "",
        note: "",
        status: 1,

      },
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
          "checklistId",
      ],
      viewFieldsPageChild:[],
      //--------------------------------------------------------------------------------------

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    checklistId: Number,
    activityNumber: Number,
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()



    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await pageViewService.getViewFieldsByPage(this.currentPage.pageId, true, [""]).then((response) => {
        this.viewFieldsPageChild = response

        const cols = Math.round(10 / this.viewFieldsPageChild.length)

        for(let viewFields of this.viewFieldsPageChild){
          viewFields.cols = cols
          this.fields.push(viewFields)
        }

      }).catch(error => this.responseError(error))

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form["activity" + this.activityNumber + "ChildId"])

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
